import React, { Component } from 'react'
import { connect } from 'react-redux'
import { glasConfig } from '../constants/Config'
import * as TemplateActions from '../actions/TemplateActions'
import * as Fetch from '../util/Fetch'
import SettingMenu from './SettingMenu'
import SettingTemplate from './SettingTemplate'
import { ModalSettingTemplate } from './Modals/Setting/ModalSettingTemplate'
import { isPWA } from '../helper/helpFunction'
import Snackbar from 'material-ui/Snackbar'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

class SettingTemplates extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isShowPopupTemplate: false,
			viewMode: 'list', // 'list' | 'create' | 'edit'
			editingTemplate: null,
			showMaxToast: false,
			showDeleteDialog: false,
			deleteTargetId: null,
		}
		this.resetTogglePopUpTemplate = this.resetTogglePopUpTemplate.bind(this)
		this.handleBackToList = this.handleBackToList.bind(this)
		this.handleCreateClick = this.handleCreateClick.bind(this)
		this.handleEditClick = this.handleEditClick.bind(this)
		this.handleDeleteClick = this.handleDeleteClick.bind(this)
		this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this)
		this.handleDeleteCancel = this.handleDeleteCancel.bind(this)
	}

	componentWillMount() {
		const { dispatch } = this.props
		const tellerId = Fetch.tellerId()
		dispatch(TemplateActions.getTemplate(tellerId))
	}

	showPopupTemplate() {
		this.setState({ isShowPopupTemplate: true })
	}

	resetTogglePopUpTemplate() {
		this.setState({ isShowPopupTemplate: false })
	}

	handleCreateClick() {
		const { Template } = this.props
		const templateCount = Array.isArray(Template.data) ? Template.data.length : 0
		if (templateCount >= glasConfig.template.template) {
			this.setState({ showMaxToast: true })
			return
		}
		this.setState({
			viewMode: 'create',
			editingTemplate: null,
		})
	}

	handleEditClick(template) {
		this.setState({
			viewMode: 'edit',
			editingTemplate: template,
		})
	}

	handleDeleteClick(templateId) {
		this.setState({
			showDeleteDialog: true,
			deleteTargetId: templateId,
		})
	}

	handleDeleteConfirm() {
		const { dispatch } = this.props
		if (this.state.deleteTargetId) {
			dispatch(TemplateActions.deleteTemplate(this.state.deleteTargetId))
		}
		this.setState({
			showDeleteDialog: false,
			deleteTargetId: null,
		})
	}

	handleDeleteCancel() {
		this.setState({
			showDeleteDialog: false,
			deleteTargetId: null,
		})
	}

	handleBackToList() {
		const { dispatch } = this.props
		const tellerId = Fetch.tellerId()
		dispatch(TemplateActions.getTemplate(tellerId))
		this.setState({
			viewMode: 'list',
			editingTemplate: null,
		})
	}

	formatDate(timestamp) {
		if (!timestamp) return ''
		// createTime is UTC timestamp (seconds or milliseconds)
		const ts = timestamp > 9999999999 ? timestamp : timestamp * 1000
		const date = new Date(ts)
		const y = date.getFullYear()
		const m = String(date.getMonth() + 1).padStart(2, '0')
		const d = String(date.getDate()).padStart(2, '0')
		return `${y}/${m}/${d}`
	}

	renderTemplateList() {
		const { Template } = this.props
		const templates = Array.isArray(Template.data) ? Template.data : []

		// Sort by created date ASC (oldest first)
		const sortedTemplates = templates.slice().sort((a, b) => {
			const dateA = a.createTime || 0
			const dateB = b.createTime || 0
			return dateA - dateB
		})

		return (
			<div style={tableStyles.wrapper}>
				<div style={tableStyles.headerRow}>
					<div style={{ ...tableStyles.cell, ...tableStyles.cellTitle }}>タイトル</div>
					<div style={{ ...tableStyles.cell, ...tableStyles.cellContent }}>内容</div>
					<div style={{ ...tableStyles.cell, ...tableStyles.cellDate }}>作成日</div>
					<div style={{ ...tableStyles.cell, ...tableStyles.cellEdit }}>編集</div>
					<div style={{ ...tableStyles.cell, ...tableStyles.cellDelete }}>削除</div>
				</div>
				{sortedTemplates.length === 0 ? (
					<div style={tableStyles.emptyState}>
						まだテンプレートが作成されていません。
					</div>
				) : (
					sortedTemplates.map((template) => (
						<div style={tableStyles.dataRow} key={template.templateId}>
							<div style={{ ...tableStyles.cell, ...tableStyles.cellTitle }}>
								{template.templateTitle}
							</div>
							<div style={{ ...tableStyles.cell, ...tableStyles.cellContent }}>
								<span style={tableStyles.contentText}>
									{template.templateContent}
								</span>
							</div>
							<div style={{ ...tableStyles.cell, ...tableStyles.cellDate }}>
								{this.formatDate(template.createTime)}
							</div>
							<div style={{ ...tableStyles.cell, ...tableStyles.cellEdit }}>
								<button
									style={tableStyles.btnEdit}
									onClick={() => this.handleEditClick(template)}
								>
									編集
								</button>
							</div>
							<div style={{ ...tableStyles.cell, ...tableStyles.cellDelete }}>
								<button
									style={tableStyles.btnDelete}
									onClick={() => this.handleDeleteClick(template.templateId)}
								>
									削除
								</button>
							</div>
						</div>
					))
				)}
			</div>
		)
	}

	render() {
		const { viewMode, editingTemplate } = this.state

		// Create/Edit mode: render SettingTemplate form
		if (viewMode === 'create' || viewMode === 'edit') {
			return (
				<>
					<div className="content">
						<h1 className="content__title">設定</h1>
						<SettingMenu />
						<div className="primary">
							<div className="primary-title primary-title-template">
								<h1 className="primary-title__main hidden-sp">
									テンプレート
								</h1>
							</div>
							<SettingTemplate
								formNo={1}
								templateTitle={editingTemplate ? editingTemplate.templateTitle : ''}
								templateContent={editingTemplate ? editingTemplate.templateContent : ''}
								templateId={editingTemplate ? editingTemplate.templateId : ''}
								onSaveSuccess={this.handleBackToList}
							/>
						</div>
					</div>
				</>
			)
		}

		// List mode
		const deleteDialogActions = [
			<FlatButton
				label="いいえ"
				primary={false}
				onClick={this.handleDeleteCancel}
			/>,
			<FlatButton
				label="はい"
				primary={true}
				onClick={this.handleDeleteConfirm}
			/>,
		]

		return (
			<>
				<ModalSettingTemplate
					isShow={this.state.isShowPopupTemplate}
					resetToggle={this.resetTogglePopUpTemplate}
				/>

				<Dialog
					title=""
					actions={deleteDialogActions}
					modal={false}
					open={this.state.showDeleteDialog}
					onRequestClose={this.handleDeleteCancel}
					bodyClassName="modal-delete-template"
					contentClassName="setting-popup-template"
				>
					<p style={{ textAlign: 'center', fontSize: '15px' }}>
						テンプレートを削除しますか？
					</p>
				</Dialog>

				<div className="content">
					<h1 className="content__title">設定</h1>
					<SettingMenu />
					<div className="primary">
						<div className="primary-title primary-title-template">
							<h1 className="primary-title__main hidden-sp">
								テンプレート
							</h1>
							<p className="primary-title__description primary-title__description-template">
								チャット相談の際に仕様できる、メッセージテンプレートを編集できます。
								<br />
								テンプレートの内容は無料で送信されます。
							</p>
							{!isPWA() && (
								<div className="link-appeal__mesage">
									<span onClick={() => this.showPopupTemplate()}>
										＞テンプレートのサンプルを見る
									</span>
								</div>
							)}
							<div style={{ marginTop: '24px' }}>
								<button
									style={createBtnStyle}
									onClick={this.handleCreateClick}
								>
									テンプレート作成
								</button>
							</div>
							{this.renderTemplateList()}
						</div>
					</div>
				</div>

				<Snackbar
					open={this.state.showMaxToast}
					message="テンプレートは最大10件まで作成できます。"
					autoHideDuration={3000}
					onRequestClose={() => this.setState({ showMaxToast: false })}
				/>
			</>
		)
	}
}

const tableStyles = {
	wrapper: {
		width: '100%',
		marginTop: '24px',
	},
	headerRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		height: '48px',
		backgroundColor: '#f7f7f7',
		borderBottom: '1px solid rgba(0,0,0,0.12)',
	},
	dataRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		height: '48px',
		backgroundColor: '#fff',
		borderBottom: '1px solid rgba(0,0,0,0.12)',
	},
	cell: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
		fontSize: '15px',
		fontFamily: 'HiraginoKakuGothicPro-W3, sans-serif',
		color: 'rgba(0,0,0,0.87)',
		// borderRight: '1px solid rgba(0,0,0,0.12)',
		boxSizing: 'border-box',
	},
	cellTitle: {
		width: '140px',
		minWidth: '140px',
	},
	cellContent: {
		flex: 1,
		justifyContent: 'center',
		paddingLeft: '13px',
		paddingRight: '13px',
		overflow: 'hidden',
	},
	cellDate: {
		width: '120px',
		minWidth: '120px',
	},
	cellEdit: {
		width: '100px',
		minWidth: '100px',
		// borderRight: '1px solid rgba(0,0,0,0.12)',
	},
	cellDelete: {
		width: '100px',
		minWidth: '100px',
		borderRight: 'none',
	},
	contentText: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		display: 'block',
		width: '100%',
	},
	emptyState: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: '400px',
		fontSize: '15px',
		lineHeight: '22px',
		color: '#1e1e1e',
		textAlign: 'center',
	},
	btnEdit: {
		backgroundColor: '#11ad9d',
		color: '#fff',
		border: 'none',
		borderRadius: '2px',
		padding: '6px 19px',
		fontSize: '15px',
		fontFamily: 'HiraginoKakuGothicPro-W6, sans-serif',
		cursor: 'pointer',
		boxShadow: '0 2px 2px rgba(0,0,0,0.24), 0 0 2px rgba(0,0,0,0.12)',
	},
	btnDelete: {
		backgroundColor: '#ec407a',
		color: '#fff',
		border: 'none',
		borderRadius: '2px',
		padding: '6px 19px',
		fontSize: '15px',
		fontFamily: 'HiraginoKakuGothicPro-W6, sans-serif',
		cursor: 'pointer',
		boxShadow: '0 2px 2px rgba(0,0,0,0.24), 0 0 2px rgba(0,0,0,0.12)',
	},
}

const createBtnStyle = {
	backgroundColor: '#11ad9d',
	color: '#fff',
	border: 'none',
	borderRadius: '2px',
	padding: '12px 30px',
	fontSize: '15px',
	fontFamily: 'HiraginoKakuGothicPro-W6, sans-serif',
	cursor: 'pointer',
	boxShadow: '0 2px 2px rgba(0,0,0,0.24), 0 0 2px rgba(0,0,0,0.12)',
}

const mapStateToProps = (state) => {
	return {
		Template: state.Template,
	}
}

export default connect(mapStateToProps)(SettingTemplates)
